// Password manager bars shown on top of the page: "save this password?" and "fill saved login".
import { KeyRound, X } from 'lucide-react';
import type { Credential } from '../core/api';
import { t } from '../core/i18n';
import { hostOf } from '../core/url';

export interface SavePrompt {
  origin: string;
  username: string;
  password: string;
  update: boolean;
}

export function PasswordSaveBar(p: { prompt: SavePrompt; onSave: () => void; onNever: () => void; onClose: () => void }) {
  return (
    <div className="pw-bar" role="dialog" aria-label={t('passwords')}>
      <KeyRound size={16} />
      <div className="grow">
        <div className="pw-title">
          {p.prompt.update ? t('updatePwQ') : t('savePwQ')} {hostOf(p.prompt.origin)}?
        </div>
        <div className="muted pw-sub">{p.prompt.username || '–'}</div>
      </div>
      <button className="btn" onClick={p.onNever}>
        {t('neverBtn')}
      </button>
      <button className="btn primary" onClick={p.onSave}>
        {p.prompt.update ? t('updateBtn') : t('saveBtn')}
      </button>
      <button className="icon-btn" aria-label={t('cancel')} onClick={p.onClose}>
        <X size={15} />
      </button>
    </div>
  );
}

export function PasswordFillBar(p: { origin: string; creds: Credential[]; onFill: (c: Credential) => void; onClose: () => void }) {
  return (
    <div className="pw-bar" role="dialog" aria-label={t('passwords')}>
      <KeyRound size={16} />
      <div className="grow">
        <div className="pw-title">{hostOf(p.origin)}</div>
        <div className="pw-choices">
          {p.creds.map((c) => (
            <button key={c.id} className="btn" onClick={() => p.onFill(c)}>
              {t('fillAs')} {c.username || '–'}
            </button>
          ))}
        </div>
      </div>
      <button className="icon-btn" aria-label={t('cancel')} onClick={p.onClose}>
        <X size={15} />
      </button>
    </div>
  );
}
